export default __webpack_public_path__ + "static/rad-74e10e54dbe793248eb204829bd270fb.png";